import { useI18n } from 'contexts/i18n'
import { useAccount } from 'contexts/account'
import { usePerson } from 'contexts/person'

export const useSmartTerritories = () => {
    const { territories } = useI18n()
    const personContext = usePerson()
    const { account } = useAccount()

    const localeSortedTerritories = Object.entries(territories)
    const [localePrioritizedTerritory] = localeSortedTerritories[0]
    const prioritizedCountryCode = personContext?.person?.homeAddress?.value?.country ?? account?.address?.country ?? localePrioritizedTerritory

    if(localePrioritizedTerritory !== prioritizedCountryCode) {
        return Object.fromEntries([
            localeSortedTerritories.find(([key]) => key === prioritizedCountryCode),
            ...localeSortedTerritories.filter(([key]) => key !== prioritizedCountryCode)
        ])
    }

    return territories
}